import { Component, Inject } from '@angular/core';
import { InternalEquipmentMultichannel } from 'src/app/model/internalEquipment';
import { SnackBarService } from '../../../../services/snackBar.service';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogDataMultichannel {
  multichannel: InternalEquipmentMultichannel;
  idEquipment: number;
  isEdit: boolean;
}

@Component({
  selector: 'app-internal-equipment-edit-multichannel',
  templateUrl: './internal-equipment-edit-multichannel.component.html',
  styleUrl: './internal-equipment-edit-multichannel.component.scss',
  standalone: false
})
export class InternalEquipmentEditMultichannelComponent {
  tituloDialog: string;

  constructor(
    public snackBarService: SnackBarService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<InternalEquipmentEditMultichannelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataMultichannel) {
    if (data.isEdit) {
      this.tituloDialog = this.translate.instant('internalEquipmentEdit.multichannels.title.edit', { name: data.multichannel.description }) as string;
    }
  }

  showReason(): boolean {
    return !this.data.multichannel.active
  }

  onOkClick(): void {
    const errs: string[] = [];

    if (this.data.multichannel.description == null) {
      errs.push(this.translate.instant('protocolEdit.dialog.area.name.error') as string);
    }

    if (this.data.multichannel.active) {
      this.data.multichannel.reasonActive = null;
    }

    if (errs.length === 0) {
      this.dialogRef.close(this.data.multichannel);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
